export const TABLE_COLUMN_PREFERENCE_OPTIONS = {
  trees: [
    { id: "name", label: "tree_cadastre_no / tree_name" },
    { id: "species_name", label: "tree_species" },
    { id: "project_name", label: "project_name" },
    { id: "area_name", label: "area" },
    { id: "health_state", label: "tree_water_stress" },
  ],
  sensors: [
    { id: "name", label: "name" },
    { id: "tree_name", label: "tree" },
    { id: "area_name", label: "area" },
    { id: "project_name", label: "project_name" },
    { id: "sensor_state", label: "sensor_status" },
    { id: "battery", label: "last_battery" },
    { id: "weekly_signal_avg", label: "signal_strength" },
  ],
  tasks: [
    { id: "title", label: "task_title" },
    { id: "tree", label: "tree" },
    { id: "area", label: "area" },
    { id: "project", label: "project_name" },
    { id: "status", label: "task_status" },
    { id: "priority", label: "task_priority" },
    { id: "assignee", label: "task_assignee" },
    { id: "scheduledAt", label: "task_due_date" },
  ],
};

export const DEFAULT_TABLE_COLUMN_PREFERENCES = {
  trees: TABLE_COLUMN_PREFERENCE_OPTIONS.trees.map((option) => option.id),
  sensors: TABLE_COLUMN_PREFERENCE_OPTIONS.sensors
    .filter((option) => option.id !== "weekly_signal_avg")
    .map((option) => option.id),
  tasks: TABLE_COLUMN_PREFERENCE_OPTIONS.tasks.map((option) => option.id),
};

export const DEFAULT_MOBILE_COLUMN_PREFERENCES = {
  trees: ["name", "health_state"],
  sensors: ["name", "sensor_state"],
  tasks: ["title", "status"],
};

export const normalizeTableColumnPreferences = (preferences) => {
  const safePreferences =
    preferences && typeof preferences === "object" && !Array.isArray(preferences)
      ? preferences
      : {};

  return Object.fromEntries(
    Object.entries(TABLE_COLUMN_PREFERENCE_OPTIONS).map(([tableKey, options]) => {
      const allowedIds = new Set(options.map((option) => option.id));
      const configured = Array.isArray(safePreferences[tableKey])
        ? safePreferences[tableKey].filter((id) => allowedIds.has(id))
        : [];
      return [
        tableKey,
        configured.length > 0 ? configured : DEFAULT_TABLE_COLUMN_PREFERENCES[tableKey],
      ];
    })
  );
};

export const normalizeMobileTableColumnPreferences = (preferences) => {
  const safePreferences =
    preferences && typeof preferences === "object" && !Array.isArray(preferences)
      ? preferences
      : {};

  return Object.fromEntries(
    Object.entries(DEFAULT_MOBILE_COLUMN_PREFERENCES).map(([tableKey, defaultColumns]) => {
      const allowedIds = new Set(
        TABLE_COLUMN_PREFERENCE_OPTIONS[tableKey]?.map((option) => option.id) || []
      );
      const configured = Array.isArray(safePreferences[tableKey])
        ? safePreferences[tableKey].filter((id) => allowedIds.has(id)).slice(0, 2)
        : [];
      return [tableKey, configured.length === 2 ? configured : defaultColumns];
    })
  );
};

export const filterColumnsByPreference = (columns, visibleIds, alwaysVisibleIds = []) => {
  const forcedSet = new Set(alwaysVisibleIds);
  const columnMap = new Map(
    columns
      .map((column) => {
        const id = column.id || column.accessor;
        return id ? [id, column] : null;
      })
      .filter(Boolean)
  );

  const orderedVisibleColumns = visibleIds.map((id) => columnMap.get(id)).filter(Boolean);

  const forcedColumns = columns.filter((column) => {
    const id = column.id || column.accessor;
    return id && forcedSet.has(id) && !visibleIds.includes(id);
  });

  const columnsWithoutId = columns.filter((column) => !(column.id || column.accessor));

  return [...orderedVisibleColumns, ...forcedColumns, ...columnsWithoutId];
};
